import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { decryptText } from '../utility/cryptoUtils';

const ProtectedRoute = () => {
  const isAuthenticated = !!localStorage.getItem('authToken');
  const role = decryptText(localStorage.getItem('role'));
  const email = decryptText(localStorage.getItem('email'));
  const allowedModule = JSON.parse(decryptText(localStorage.getItem('allowedModule')) || '[]');
  const location = useLocation();

  console.log("allowedModule in ProtectedRoute:", allowedModule);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const currentPath = location.pathname.toLowerCase();

const moduleToRouteMap = {
  dashboard: '/dashboard',
  reports: '/reports',
  tickets: '/tickets',
  departments: '/department',
  vendors: '/vendor',
  viewticket: '/viewticket',
  registeredvendors: '/registeredvendors',
  clients: '/client',
  category: '/category',
  'staff management': '/staff',
  user: '/user',
};



  // 🧠 Determine if current path is allowed based on allowed modules
  const isAllowed = allowedModule.some((module) => {
    console.log("Checking module in ProtectedRoute:", module);
    const routeSegment = moduleToRouteMap[module.toLowerCase()];
    console.log("Mapped routeSegment in ProtectedRoute:", routeSegment);
    return routeSegment && currentPath.startsWith(routeSegment);
  });
console.log("isAllowed in ProtectedRoute:", isAllowed);
  if (!isAllowed) {
    return <Navigate to="*" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
